import { TableLayout } from '@templates/TableLayout/TableLayout';

import { UserManagementHeader } from './UserManagementHeader';
import { UserManagementTable } from './UserManagementTable';

export const UserManagement = () => {
  return (
    <TableLayout
      header={<UserManagementHeader />}
      content={<UserManagementTable />}
    />
  );
};
